import type { MachineQuotationItemDto } from '@api/machines'

export function flattenMachineItems(
  machineItems: MachineQuotationItemDto[] | null
) {
  const transformedMachineItems =
    machineItems?.map(machineItem => {
      return {
        attachments:
          machineItem.machineAttachments?.map(attachment => {
            return {
              ...attachment,
              withinMachineItemId: machineItem.quotationItemId,
              quantity: machineItem.quantity ?? 1
            }
          }) ?? [],
        machineItem: {
          ...machineItem,
          price:
            (machineItem?.price ?? 0) -
            (machineItem?.machineAttachments?.reduce((sum, item) => {
              const price = item?.price ?? 0
              const quantity = item?.quantity ?? 1

              return sum + price * quantity
            }, 0) ?? 0)
        }
      }
    }) ?? []

  const flattenedMachineItems = transformedMachineItems.flatMap(item => [
    item.machineItem,
    ...item.attachments
  ])

  return flattenedMachineItems
}
